import { render } from "./HosPalProfileDetails.vue?vue&type=template&id=58926800"
import script from "./HosPalProfileDetails.ts?vue&type=script&lang=js&external"
export * from "./HosPalProfileDetails.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__